import { createContext, useContext } from "react";

export type CascadiaTheme = "light" | "dark" | "system";

export interface Themes {
  theme: CascadiaTheme;
  setTheme: (theme: CascadiaTheme) => void;
}

export const ThemeContext = createContext<Themes>({
  theme: "system",
  setTheme() {
    console.warn(
      "Attempted to change the theme but couldn't find a ThemeContext.Provider."
    );
  },
});

export function useTheme() {
  return useContext(ThemeContext);
}
